import { Controller } from "@hotwired/stimulus"

// Handles loading and displaying event indicators on calendar dates
export default class extends Controller {
  static targets = ["indicator"]
  static values = {
    url: String,
    startDate: String,
    endDate: String
  }

  connect() {
    // Event indicators are pre-rendered server-side for initial load
    // This controller can be used for dynamic updates if needed
  }

  // Refresh event indicators for the current month
  async refresh() {
    if (!this.hasUrlValue) return

    try {
      const response = await fetch(this.urlValue, {
        headers: {
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (!response.ok) return

      const data = await response.json()
      this.updateIndicators(data.events_by_date)
    } catch (error) {
      console.error("Failed to refresh event indicators:", error)
    }
  }

  // Update indicator dots on calendar dates
  updateIndicators(eventsByDate) {
    this.indicatorTargets.forEach(indicator => {
      const date = indicator.dataset.date
      const events = eventsByDate[date] || []
      const hasEvents = events.length > 0

      // Toggle visibility based on whether date has events
      indicator.classList.toggle("hidden", !hasEvents)

      // Update event count if present
      const countElement = indicator.querySelector("[data-count]")
      if (countElement) {
        countElement.textContent = events.length
      }
    })
  }

  // Handle calendar navigation - could trigger refresh
  handleMonthChange(event) {
    const { startDate, endDate } = event.detail
    this.startDateValue = startDate
    this.endDateValue = endDate
    this.refresh()
  }
}
